import { render } from "./shopMagic.vue?vue&type=template&id=070eaa0a&scoped=true"
import script from "./shopMagic.vue?vue&type=script&lang=js"
export * from "./shopMagic.vue?vue&type=script&lang=js"

import "./shopMagic.vue?vue&type=style&index=0&id=070eaa0a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070eaa0a"]])

export default __exports__